import styled from 'styled-components';

export default styled.div`
  padding-top: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 25px;
`;
